import Image from 'next/image';
import instanst from '@/public/images/datepicker/instanst.svg';
import Typography from '@/components/UI/typography/Typography';
import Box from '@/components/UI/box/Box';
import peak from '@/public/images/datepicker/peak.svg';
import styles from './InstanstPeakDescription.module.scss';
const InstanstPeakDescription = ({
  fullText = false
}) => {
  return <Box data-sentry-element="Box" data-sentry-component="InstanstPeakDescription" data-sentry-source-file="InstanstPeakDescription.tsx">
      <Box className={`${styles['instant-peaker-wrapper']} ${styles['instant-mb-4']}`} data-sentry-element="Box" data-sentry-source-file="InstanstPeakDescription.tsx">
        <Image src={instanst} alt="instant" width={16} height={16} data-sentry-element="Image" data-sentry-source-file="InstanstPeakDescription.tsx" />
        <Typography variant="bodyS" color="neutral_main" data-sentry-element="Typography" data-sentry-source-file="InstanstPeakDescription.tsx">
          در این روز ها
          {` “آنی${fullText ? ` و قطعی` : ''}`}” رزرو کنید.
        </Typography>
      </Box>

      <Box className={styles['instant-peaker-wrapper']} data-sentry-element="Box" data-sentry-source-file="InstanstPeakDescription.tsx">
        <Image src={peak} alt="instant" width={16} height={16} data-sentry-element="Image" data-sentry-source-file="InstanstPeakDescription.tsx" />
        <Typography className={styles['peak-title']} variant="bodyS" color="neutral_main" data-sentry-element="Typography" data-sentry-source-file="InstanstPeakDescription.tsx">
          روزهای پیک{' '}
        </Typography>
      </Box>
    </Box>;
};
export default InstanstPeakDescription;